module.exports = "<h1>Support Page</h1>"


//////////////////
// WEBPACK FOOTER
// ./src/opc/support/support.component.html
// module id = ./src/opc/support/support.component.html
// module chunks = main